import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesParcelEditMain } from './modules/ui/Main';

const ParcelEditPage = (
  <SuspensePage>
    <PagesParcelEditMain />
  </SuspensePage>
);

export default ParcelEditPage;
